// import components
import { styled, Box } from '@mui/material';

export const StyledDutyInformationTopBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  overflowY: 'auto',
  overflowX: 'hidden',
  marginBottom: theme.spacing(4)
}));
